import { Outlet } from 'react-router-dom';

import { HeaderPage } from 'components/header/HeaderPage';
import { Row } from 'enable-ui';

import { useTrainerLayoutController } from '../core/controller/trainer-layout';

export const TrainerLayout = () => {
  const { onClickAdd } = useTrainerLayoutController();

  return (
    <Row direction="column" className="full-width">
      <HeaderPage title="Trainers" onClick={onClickAdd} />
      <Outlet />
    </Row>
  );
};
